module.exports = __webpack_public_path__ + "img/Twitter.30e1edb7.svg";